import linearProgressClasses from "@mui/material/LinearProgress/linearProgressClasses";
export const MuiLinearProgressTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                borderRadius: dt.borderRadius.pill,
                [`.${linearProgressClasses.bar}`]: {
                    borderRadius: dt.borderRadius.pill,
                },
                [`.${linearProgressClasses.colorPrimary}`]: {
                    background: dt.color.primary.key,
                    [`.${linearProgressClasses.bar}`]: {
                        background: dt.color.primary.container,
                    },
                },
                [`.${linearProgressClasses.colorSecondary}`]: {
                    background: dt.color.secondary.key,
                    [`.${linearProgressClasses.bar}`]: {
                        background: dt.color.secondary.container,
                    },
                },
            },
        },
    };
};
